import { useQuery } from 'react-query';
import TermsApiService from '@/modules/terms/services/TermsApiService';

export const TERMS_CURRENT_KEY = 'terms-current';

// Blocking gate for external users: must accept the active terms before using the app.
// Applies both during onboarding and afterwards (new version published / token refreshed).
// Note: the /me response strips `isRoot` (projected out in UserService), so we use its
// mirror `isAuditor` -- the same signal App.jsx uses to route external users to onboarding.
// isAuditor === true means the user belongs to the root (internal) space; external = falsy.
export const useTermsGate = (user) => {
  const enabled = !!user && !user.isAuditor;

  const { data, isLoading, isError, refetch } = useQuery(
    TERMS_CURRENT_KEY,
    () => TermsApiService.getCurrent(),
    {
      enabled,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  );

  // ponytail: fail open. No active terms (null) or a failed fetch must not lock the
  // whole app out -> only block when the API explicitly says accepted === false.
  const needsAcceptance = enabled && !!data && data.accepted === false;

  return {
    enabled,
    loading: enabled && isLoading,
    needsAcceptance,
    isError,
    terms: data,
    refetch,
  };
};
